import { render, staticRenderFns } from "./CFCompletedTasks.vue?vue&type=template&id=4ebe0c66&"
import script from "./CFCompletedTasks.vue?vue&type=script&lang=ts&"
export * from "./CFCompletedTasks.vue?vue&type=script&lang=ts&"
import style0 from "./CFCompletedTasks.vue?vue&type=style&index=0&id=4ebe0c66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports